import React, { useEffect, useRef, useMemo, useState, memo } from "react";
import {
  LandingColumn,
  LandingContainer,
  LandingHeadline,
  LandingHeadlineContainer,
  LandingLogoContainer,
  LandingSubtitleContainer,
  LandingVideo,
  LandingWrapper,
  LandingHeadings,
  LandingSubtitleSVG,
} from "../styles/components/landing";
import VideoMux from "./videoMux";
import animations from "../animations/animations";
import { BREAKPOINTS } from "../styles/variables/breakpoints";
import { SubtitleHeading, TridentLogo } from "../data/icons";

const LandingComponent = props => {
  const wrapperRef = useRef(null);
  const landingHeadingsRef = useRef(null);
  const headlineRef = useRef(null);
  const [hasMounted, setHasMounted] = useState(false);

  const { articleData, isLoaded, ...rest } = props;

  const playVideo = !!isLoaded;

  const componentContent = useMemo(() => {
    return Object.values(rest)
      .filter(component => component?.moduleTitle)
      .map(component => ({
        key: component.moduleTitle,
        content: component,
      }));
  }, [rest]);

  const videoComponent = componentContent.find(
    c => c.key === "component--landing-video"
  );

  const headlineComponent = componentContent.find(
    c => c.key === "component--landing-headline"
  );

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (
      !landingHeadingsRef.current ||
      typeof window === "undefined" ||
      !hasMounted
    )
      return;

    const mm = animations.matchMedia();

    mm.add(`(max-width: ${BREAKPOINTS.sm + 1}px)`, () => {
      setTimeout(() => {
        animations.parallax(landingHeadingsRef.current, 10, true);
      }, 500);
    });

    return () => mm.revert();
  }, [hasMounted]);

  useEffect(() => {
    if (typeof window === "undefined" || !hasMounted) return;
    const timeout = setTimeout(() => {
      animations.ScrollTrigger.refresh(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [hasMounted]);

  return (
    <LandingWrapper ref={wrapperRef}>
      <LandingContainer>
        {hasMounted && videoComponent && (
          <LandingColumn $landingVideo suppressHydrationWarning={true}>
            <LandingVideo>
              <VideoMux
                videoContent={videoComponent.content}
                muxvideo={videoComponent.content?.muxvideo}
                playVideo={playVideo}
                articleData={articleData}
              />
            </LandingVideo>
          </LandingColumn>
        )}
        <LandingColumn>
          {hasMounted && (
            <LandingHeadings ref={landingHeadingsRef}>
              <LandingLogoContainer>
                <LandingSubtitleSVG
                  $primaryColor={articleData.colors?.secondary}
                  $secondaryColor={articleData.colors?.secondary}
                >
                  <TridentLogo />
                </LandingSubtitleSVG>
              </LandingLogoContainer>
              {headlineComponent && (
                <LandingHeadlineContainer ref={headlineRef}>
                  <LandingHeadline
                    $articleId={articleData.id}
                    $fontColor={articleData.colors?.primary}
                    dangerouslySetInnerHTML={{
                      __html: headlineComponent.content.text,
                    }}
                  ></LandingHeadline>
                </LandingHeadlineContainer>
              )}
              <LandingSubtitleContainer>
                <LandingSubtitleSVG
                  $primaryColor={articleData.colors?.primary}
                  $secondaryColor={articleData.colors?.secondary}
                  $subtitle
                >
                  <SubtitleHeading />
                </LandingSubtitleSVG>
              </LandingSubtitleContainer>
            </LandingHeadings>
          )}
        </LandingColumn>
      </LandingContainer>
    </LandingWrapper>
  );
};

export default memo(LandingComponent);
